import { render } from "./Menu.vue?vue&type=template&id=45c75f02&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=45c75f02&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c75f02"]])

export default __exports__